/**
 * Helper to get all descendant IDs of a category recursively
 * @param {Array} categories
 * @param {number} parentId
 * @returns {Array<number>}
 */
export const getDescendantIds = (categories, parentId) => {
  if (!categories || !Array.isArray(categories)) return [];

  const children = categories.filter(
    (cat) => parseInt(cat.parent_id) === parseInt(parentId),
  );
  let ids = children.map((cat) => cat.id);

  children.forEach((child) => {
    ids = [...ids, ...getDescendantIds(categories, child.id)];
  });

  return ids;
};

/**
 * Returns a Set of IDs belonging to the "Cake Store" category and its descendants
 * @param {Array} categories
 * @returns {Set<number>}
 */
export const getExcludedCategoryIds = (categories) => {
  if (!categories || !Array.isArray(categories)) return new Set();

  const cakeStore = categories.find((cat) => cat.name === "Cake Store");
  if (!cakeStore) return new Set();

  const descendantIds = getDescendantIds(categories, cakeStore.id);
  return new Set([cakeStore.id, ...descendantIds]);
};

/**
 * Filters out categories that belong to the excluded IDs set
 * @param {Array} categories
 * @param {Set<number>} excludedIds
 * @returns {Array}
 */
export const filterExcludedCategories = (categories, excludedIds) => {
  if (!categories || !Array.isArray(categories)) return [];
  if (!excludedIds || excludedIds.size === 0) return categories;

  return categories.filter((cat) => !excludedIds.has(cat.id));
};

/**
 * Filters out products belonging to excluded categories
 * @param {Array} products
 * @param {Set<number>} excludedIds
 * @returns {Array}
 */
export const filterExcludedProducts = (products, excludedIds) => {
  if (!products || !Array.isArray(products)) return [];
  if (!excludedIds || excludedIds.size === 0) return products;

  return products.filter((p) => !excludedIds.has(parseInt(p.category_id)));
};
